import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Permanently hide/remove the platform-injected "Made with Emergent" badge.
// Ships via bundle.js so it survives the preview/production ingress HTML rewrite.
(function hideEmergentBadge() {
  if (typeof document === "undefined") return;
  const SELECTOR = '#emergent-badge, a[href*="utm_source=emergent-badge"]';

  const styleEl = document.createElement("style");
  styleEl.textContent =
    '#emergent-badge,a[href*="utm_source=emergent-badge"]{display:none !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important;}';
  (document.head || document.documentElement).appendChild(styleEl);

  const sweep = () => {
    document.querySelectorAll(SELECTOR).forEach((n) => {
      n.style.setProperty("display", "none", "important");
      n.style.setProperty("visibility", "hidden", "important");
      n.style.setProperty("opacity", "0", "important");
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  };

  sweep();
  const start = () => {
    sweep();
    const root = document.documentElement || document.body;
    if (root) new MutationObserver(sweep).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  window.addEventListener("load", sweep);
})();

const QUERY_STALE_TIME_MS = 60000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
